import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./Commande.css";

const Commande = () => {
  const location = useLocation();
  const produit = location.state?.produit;

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!produit) {
      alert("Aucun produit sélectionné !");
      return;
    }

    setLoading(true);

    // 🧾 Message que le client enverra sur WhatsApp
    const whatsappMessage = `
Bonjour 👋, je suis intéressé(e) par ce produit :

📦 *${produit.nom}*
💰 *Prix :* ${produit.prix}

Voici mes coordonnées :
👤 *${formData.nom} ${formData.prenom}*
📧 *${formData.email}*
📱 *${formData.telephone}*
    `;

    // 📧 Message pour la boutique (alerte automatique)
    const emailMessage = `
🧾 Nouvelle demande d'intérêt pour un produit :

📦 Produit : ${produit.nom}
💰 Prix : ${produit.prix}

👤 Client :
- Nom : ${formData.nom} ${formData.prenom}
- Email : ${formData.email}
- Téléphone : ${formData.telephone}

🕒 Date : ${new Date().toLocaleString()}
    `;

    const templateParams = {
      to_email: "alwaleedtheholding@gmail.com",
      from_name: `${formData.nom} ${formData.prenom}`,
      client_email: formData.email,
      telephone: formData.telephone,
      produit_nom: produit.nom,
      produit_prix: produit.prix,
      message: emailMessage,
    };

    // 🔔 Envoi automatique d'une alerte mail à la boutique
    emailjs
      .send(
        "service_2xqll8e", // Ton service ID
        "template_bloxjdw", // Ton template ID
        templateParams,
        "EVxDjU6lhJ-PsEdH3" // Ta clé publique
      )
      .then(
        (response) => {
          console.log("✅ Alerte email envoyée :", response.status, response.text);
          alert("✅ Votre demande a été prise en compte !");
          
          // 🔁 Redirection WhatsApp (le client voit le message mais décide d'envoyer)
          const whatsappNumber = "221774134848"; // Numéro de la boutique
          const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
          window.location.href = whatsappLink;
        },
        (error) => {
          console.error("❌ Erreur EmailJS :", error);
          alert("Une erreur est survenue lors de l’envoi de votre demande.");
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <div className="commande-container">
      <h1>🧾 Commander {produit?.nom}</h1>

      <div className="commande-details">
        <img src={produit?.image} alt={produit?.nom} />
        <h2>{produit?.nom}</h2>
        <p>{produit?.prix}</p>
      </div>

      <form className="commande-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="nom"
          placeholder="Nom"
          value={formData.nom}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="prenom"
          placeholder="Prénom"
          value={formData.prenom}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Adresse e-mail"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="telephone"
          placeholder="Numéro de téléphone"
          value={formData.telephone}
          onChange={handleChange}
          required
        />

        <button type="submit" className="btn-commande" disabled={loading}>
          {loading ? "⏳ Envoi en cours..." : "Valider ma commande"}
        </button>
      </form>
    </div>
  );
};

export default Commande;
